<template>
  <div>
    <div v-if="filter.type === FILTER_TYPE.LIST && filter.values.length > 0">
      <ul>
        <li
          v-for="(filterItem, index) in filter.values"
          :key="`FilterPart-${filter.id}-Item-${filterItem.id}-${index}`"
        >
          <div class="checkbox">
            <input
              type="checkbox"
              :id="
                `filterpart-${filter.id}-filteritem-${filterItem.id}-${index}`
              "
              :checked="filter.selectedValues.includes(filterItem.value)"
              class="check-box"
              @change="onChangeFilterItem(filterItem)"
            />
            <label
              :for="
                `filterpart-${filter.id}-filteritem-${filterItem.id}-${index}`
              "
              >{{ filterItem.title }}</label
            >
          </div>
        </li>
      </ul>
    </div>

    <div v-else-if="filter.type === FILTER_TYPE.RANGE">
      <FilterItemRange :filter="filter" />
    </div>

    <!-- <div
      v-else-if="
        filter.type===FILTER_TYPE.RANGE &&
          filter.type.toLowerCase() === 'rate'
      "
    >
      <ul>
        <li>
          <div class="checkbox">
            <input
              type="checkbox"
              :id="filter.id"
              :checked="filter.isSelected"
              v-model="filter.isSelected"
              class="check-box"
              @change="
                onChangeFilterItem(filter, filter.type)
              "
            />
            <label :for="filter.id">
              {{ filter.title }}
            </label>
          </div>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import FilterItemRange from "./FilterItemRange";
import { mapActions } from "vuex";
import { FILTER_TYPE } from "@/constantData";

export default {
  name: "FilterItem",

  props: ["filter"],

  components: {
    FilterItemRange,
  },

  data() {
    return {
      FILTER_TYPE,
      needMoreBtnFlag: false,
    };
  },

  computed: {
    moreBtnText() {
      if (this.needMoreBtnFlag) {
        return "بیشتر";
      }
      return "کمتر";
    },
  },

  methods: {
    ...mapActions({
      onChangeFilter: "onChangeFilter",
    }),

    onChangeFilterItem(filterItem) {
      this.onChangeFilter({ filter: this.filter, filterItem });
    },

    needMoreBtn(length) {
      if (this.filter.values?.length > 3) {
        this.needMoreBtnFlag = true;
      }
      return this.filter.values?.length > 3;
    },

    toggleMoreBtn() {
      this.needMoreBtnFlag = !this.needMoreBtnFlag;
    },
  },

  created() {
    // this.needMoreBtn(this.filter.children);
  },
};
</script>
